/**
 * Person-label rule (DNKADM-0338 U2 + amendment): an operator is never shown a bare
 * identifier as a person. A label is `name → email → UNNAMED_MEMBER`, where a
 * whitespace-only value counts as absent — the same rule at every render site (the
 * Book-on-behalf member/staff/resource labels, the member-search dialog rows).
 */
export const UNNAMED_MEMBER = 'Unnamed member';

/** `value` when it carries visible text, otherwise `null`. */
export function nonEmpty(value: string | null | undefined): string | null {
  return value !== null && value !== undefined && value.trim() !== '' ? value : null;
}

/** `name → email → "Unnamed member"` — never an id, never empty. */
export function personLabel(
  name: string | null | undefined,
  email: string | null | undefined,
): string {
  return nonEmpty(name) ?? nonEmpty(email) ?? UNNAMED_MEMBER;
}
